/** @format */
import { Injectable } from '@angular/core';
import { CustomCourseUnitAttainment } from 'common-typescript/types';
import { UiOperationType } from 'sis-components';
import { StudentPlanActionsService } from './student-plan-actions.service';

@Injectable()
export class StudentPlanActionsServiceWithAttainmentDetails extends StudentPlanActionsService {
    openCustomCourseUnitAttainmentDetailsModal(customCourseUnitAttainment: CustomCourseUnitAttainment): void {
        this.uiOperationSubject.next({
            uiOperationType: UiOperationType.OPEN_CUSTOM_COURSE_UNIT_ATTAINMENT_DETAILS_MODAL,
            target: customCourseUnitAttainment,
        });
    }
}
